import { memo } from "react";
import StockLogo from "@/components/StockLogo";
import { fmt } from "./utils";

const ETFsTab = memo(({ etfs, etfTicks, navigate }) => {
  if (!etfs.length) return <p className="text-sm text-gray-400 py-8 text-center">No ETFs tracking this index found</p>;
  return (
    <div data-testid="etfs-tab">
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="text-left text-xs font-medium text-gray-500 uppercase py-3 px-3">ETF</th>
              <th className="text-right text-xs font-medium text-gray-500 uppercase py-3 px-3">Mkt Price (1D)</th>
              <th className="text-right text-xs font-medium text-gray-500 uppercase py-3 px-3">Expense Ratio</th>
              <th className="text-right text-xs font-medium text-gray-500 uppercase py-3 px-3">AUM</th>
            </tr>
          </thead>
          <tbody>
            {etfs.map((e) => {
              const tick = etfTicks[e.symbol] || {};
              const price = tick.last_price || e.last_price || 0;
              const chg = tick.change || e.change || 0;
              const chgPct = tick.change_percent || e.change_percent || 0;
              const isPos = chgPct >= 0;
              return (
                <tr
                  key={e.symbol}
                  className="border-b border-gray-100 last:border-0 hover:bg-gray-50 cursor-pointer transition-colors"
                  onClick={() => navigate(`/stock/${e.symbol}`)}
                  data-testid={`etf-row-${e.symbol}`}
                >
                  <td className="py-3 px-3">
                    <div className="flex items-center gap-3">
                      {e.logo_url ? (
                        <img src={e.logo_url} alt={e.symbol} className="w-8 h-8 rounded-full object-cover border border-gray-200" />
                      ) : (
                        <StockLogo symbol={e.symbol} name={e.name} size="sm" />
                      )}
                      <div>
                        <p className="text-sm font-semibold text-gray-900 leading-tight">{e.name}</p>
                        <p className="text-xs text-gray-400">{e.symbol}</p>
                      </div>
                    </div>
                  </td>
                  <td className="py-3 px-3 text-right">
                    <p className="text-sm font-semibold">{price ? `₹${fmt(price)}` : "--"}</p>
                    {(price > 0) && (
                      <p className={`text-xs ${isPos ? "text-[#00b386]" : "text-[#eb5b3c]"}`}>
                        {chg ? `${chg >= 0 ? "+" : ""}${chg.toFixed(2)} ` : ""}
                        ({isPos ? "+" : ""}{chgPct.toFixed(2)}%)
                      </p>
                    )}
                  </td>
                  <td className="py-3 px-3 text-right text-sm text-gray-600">
                    {e.expense_ratio != null ? `${e.expense_ratio}%` : "--"}
                  </td>
                  <td className="py-3 px-3 text-right text-sm text-gray-600">
                    {e.aum != null ? `₹${e.aum.toLocaleString("en-IN")} Cr` : "--"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
});

export default ETFsTab;
